import Vue from 'vue'
import VueResizeObserver from 'vue-draggable-resizable'

Vue.use(VueResizeObserver)
